import styled from 'styled-components'
import { BORDER, COLOR, FONT, GTR } from '@farewill/ui/tokens'

const StyledBanner = styled.p`
  margin: 0 0 ${GTR.M};
  padding: ${GTR.S};
  background-color: ${COLOR.STATE.ACTIVE_10};
  border-radius: ${BORDER.RADIUS.S};
  color: ${COLOR.GREY.DARK};
  font-size: ${FONT.SIZE.S};
  font-weight: ${FONT.WEIGHT.MEDIUM};
  line-height: 1.5;
`

const SharedContactsBanner = () => (
  <StyledBanner role="note">
    This section uses shared contacts. Editing a contact automatically updates
    it across the estate.
  </StyledBanner>
)

export default SharedContactsBanner
